module.exports = __webpack_public_path__ + "static/media/action-red-icon.ea9b693c.svg";